import { render, staticRenderFns } from "./ArticlesOnSales.vue?vue&type=template&id=4a3164e3&scoped=true"
import script from "./ArticlesOnSales.vue?vue&type=script&lang=js"
export * from "./ArticlesOnSales.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOnSales.vue?vue&type=style&index=0&id=4a3164e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3164e3",
  null
  
)

export default component.exports